var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.showVisible,
        "append-to-body": "",
        width: "60%",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.showVisible = $event
        },
        close: _vm.closeEdit,
        open: _vm.openEdit,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticStyle: { "margin-left": "30px", "margin-right": "10px" },
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "mini",
            "label-position": "left",
            "label-width": "100px",
          },
        },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("基本信息")]),
          _c(
            "el-form-item",
            { attrs: { label: "商品名称", prop: "name" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "text",
                  placeholder: "不超过5个字",
                  maxlength: "5",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "副标题", prop: "subTitle" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "text",
                  placeholder: "不超过5个字",
                  maxlength: "5",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.subTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "subTitle", $$v)
                  },
                  expression: "form.subTitle",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动时间", required: "" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "开始日期",
                  "picker-options": _vm.pickerOptionStart(),
                },
                model: {
                  value: _vm.form.startTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startTime", $$v)
                  },
                  expression: "form.startTime",
                },
              }),
              _c("span", [_vm._v(" - ")]),
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "结束日期",
                  "picker-options": _vm.pickerOptionEnd(),
                },
                model: {
                  value: _vm.form.endTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "endTime", $$v)
                  },
                  expression: "form.endTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动头图", required: "" } },
            [
              _c(
                "el-upload",
                {
                  ref: "uploadRef",
                  class: { disabled: _vm.uploadDisabled },
                  staticStyle: { width: "100%" },
                  attrs: {
                    action: _vm.doUpload,
                    headers: _vm.headers,
                    name: "file",
                    "list-type": "picture-card",
                    "before-upload": function (file) {
                      return _vm.handleBeforeUpload(file, 750)
                    },
                    "on-success": function (response, file, fileList) {
                      return _vm.uploadSuccess(response, file, fileList)
                    },
                    "on-error": _vm.handleUploadError,
                    "on-remove": _vm.handleRemove,
                    "file-list": _vm.fileList,
                    "show-file-list": true,
                    data: { code: "activity" },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v("jpg/png格式，宽度750，不超过500kb。")]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
              },
            },
            [
              _c("div", { staticClass: "title-box" }, [
                _vm._v("优惠券\n        "),
                _c("div", { staticClass: "tipsBox" }, [
                  _c("image", {
                    staticStyle: {
                      "vertical-align": "middle",
                      width: "20px",
                      height: "20px",
                    },
                    attrs: { src: "./static/tips.png" },
                  }),
                  _c("span", [
                    _vm._v(
                      "本次活动可供用户领取的总次数，根据可领取用户数填写！"
                    ),
                  ]),
                ]),
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-circle-plus-outline",
                    size: "mini",
                  },
                  on: { click: _vm.handleAddCoupon },
                },
                [_vm._v("添加优惠券/礼包")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "10px" } },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.couponItem,
                    border: "",
                    size: "mini",
                    "max-height": "280px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      type: "index",
                      width: "50",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "优惠券名称",
                      align: "center",
                      prop: "name",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "所属礼包",
                      align: "center",
                      prop: "giftName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "金额/个",
                      align: "center",
                      prop: "discountsMoney",
                      width: "80",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "剩余数量",
                      align: "center",
                      prop: "surplusNum",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "每次领取数量",
                      align: "center",
                      prop: "num",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("avue-input-number", {
                              staticStyle: { width: "8vw" },
                              attrs: { "min-rows": "0" },
                              model: {
                                value: scope.row.num,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "num", $$v)
                                },
                                expression: "scope.row.num",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deletes(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "margin-top-10",
              attrs: { label: "原价", prop: "marketPrice" },
            },
            [
              _c("el-input", {
                staticStyle: { width: "100px" },
                attrs: { type: "number", size: "mini" },
                model: {
                  value: _vm.form.marketPrice,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "marketPrice", _vm._n($$v))
                  },
                  expression: "form.marketPrice",
                },
              }),
              _vm._v("\n      元\n    "),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动价", prop: "salePrice" } },
            [
              _c("el-input", {
                staticStyle: { width: "100px" },
                attrs: { type: "number", size: "mini" },
                model: {
                  value: _vm.form.salePrice,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "salePrice", _vm._n($$v))
                  },
                  expression: "form.salePrice",
                },
              }),
              _vm._v("\n      元\n    "),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "库存", prop: "personTime", required: "" } },
            [
              !_vm.isEdit
                ? _c(
                    "div",
                    [
                      _c("el-input", {
                        staticStyle: { width: "110px" },
                        attrs: { type: "number", placeholder: "请输入整数" },
                        model: {
                          value: _vm.form.personTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "personTime", _vm._n($$v))
                          },
                          expression: "form.personTime",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-descriptions",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            column: 2,
                            border: "",
                            direction: "vertical",
                            size: "mini",
                            contentStyle: _vm.rowCenter,
                            labelStyle: _vm.rowCenter,
                          },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "总库存" } },
                            [_vm._v(_vm._s(_vm.form.personTime))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "剩余库存" } },
                            [_vm._v(_vm._s(_vm.form.surplus))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "margin-left": "10px",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "80px" },
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  _vm.isAddPersonTime = !_vm.isAddPersonTime
                                },
                              },
                            },
                            [_vm._v("添加库存")]
                          ),
                          _vm.isAddPersonTime
                            ? _c("el-input", {
                                staticStyle: {
                                  width: "110px",
                                  "margin-top": "10px",
                                },
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入整数",
                                },
                                model: {
                                  value: _vm.form.addPersonTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "addPersonTime",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "form.addPersonTime",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "每人限购", prop: "everyPersonTime" } },
            [
              _c("el-input", {
                staticStyle: { width: "110px" },
                attrs: { type: "number", placeholder: "请输入整数" },
                model: {
                  value: _vm.form.everyPersonTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "everyPersonTime", _vm._n($$v))
                  },
                  expression: "form.everyPersonTime",
                },
              }),
              _vm._v("\n      次\n    "),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: " 活动规则", required: "" } },
            [
              _c("rich-text-editor", {
                model: {
                  value: _vm.form.rule,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "rule", $$v)
                  },
                  expression: "form.rule",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeEdit } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
      _vm.selectVisible
        ? _c("select-coupon", {
            ref: "selectCoupon",
            on: { getCouponItem: _vm.getCouponItem },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }